import React from 'react'
import { Col, Row } from 'reactstrap'

const Loader = () => {
    return (
        <>
            <Row>
                <Col className="d-flex justify-content-center py-5 my-lg-5">
                    <div className='py-5 my-5'>
                        <div className="slider_sppiner"></div>
                    </div>
                </Col>
            </Row>
        </>
    )
}

export default Loader
